import { Check } from 'lucide-react';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from '../ui/dialog';

export function EditMessageDialog({ editingItem, setEditingItem, editMessage, setEditMessage, handleSaveEdit }) {
  return (
    <Dialog open={!!editingItem} onOpenChange={() => setEditingItem(null)}>
      <DialogContent className="bg-surface border-[#262626]">
        <DialogHeader>
          <DialogTitle>Edit Message for {editingItem?.artist_name}</DialogTitle>
        </DialogHeader>
        <div className="py-4">
          <Textarea
            value={editMessage}
            onChange={(e) => setEditMessage(e.target.value)}
            placeholder="Write your custom message for the dubplate..."
            className="min-h-[150px] input-dark"
            data-testid="edit-message-textarea"
          />
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={() => setEditingItem(null)}>Cancel</Button>
          <Button onClick={handleSaveEdit} className="btn-primary">
            <Check className="w-4 h-4 mr-2" />Save Changes
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
